import { Injectable } from '@angular/core';
import { EntityState, EntityStore } from '@examdojo/state';
import { StudentClassAssignmentStoreModel } from './student-class-assignment.model';

export type StudentClassAssignmentState = EntityState<StudentClassAssignmentStoreModel>;

@Injectable({ providedIn: 'root' })
export class StudentClassAssignmentStore extends EntityStore<
  StudentClassAssignmentState,
  StudentClassAssignmentStoreModel,
  'assignment_id'
> {
  constructor() {
    super({
      name: 'student-class-assignments',
      idKey: 'assignment_id',
    });
  }
}
